import { render, staticRenderFns } from "./mixClickableCell.pug?vue&type=template&id=56ceeb24&lang=pug&"
import script from "./mixClickableCell.js?vue&type=script&lang=js&"
export * from "./mixClickableCell.js?vue&type=script&lang=js&"
import style0 from "./mixClickableCell.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56ceeb24')) {
      api.createRecord('56ceeb24', component.options)
    } else {
      api.reload('56ceeb24', component.options)
    }
    module.hot.accept("./mixClickableCell.pug?vue&type=template&id=56ceeb24&lang=pug&", function () {
      api.rerender('56ceeb24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warrantyLayout/components/warrantySticky/components/mixClickableCell/index.vue"
export default component.exports